import { useEffect } from "react";

import Injuries from "../../../../../components/cm/Dashboard/FullPages/ClientDetail/Injuries";
import Navigation from "../../../../../components/navigations/client/detail/medical/navigation";
import useParentLoaderData from "../../../../../hooks/useParentLoaderData";
import { NavigationHistoryService } from "../../../../../services/navigation-history-service";

export default () => {
  const { _case } = useParentLoaderData(2);

  useEffect(() => {
    const navService = new NavigationHistoryService();
    navService.save("client-detail", "/medical/injuries");
  }, []);

  return (
    <Navigation activeTab="injuries" _case={_case}>
      <Injuries caseObj={_case} />
    </Navigation>
  );
};
